import axios from 'axios';

export default class YoutubeDataAccess {

    getPlaylist(playlistName, playlistId) {
        return new Promise((resolve, reject) => {
            var apiKey = "AIzaSyAr6D4rJNGM_oe5nwHpozli5n2cevQx7Ls";
           
            axios.get(`https://www.googleapis.com/youtube/v3/playlistItems?part=contentDetails,id,snippet,status&playlistId=${playlistId}&maxResults=50&key=${apiKey}`,
                {
                    headers: {
                        'Content-Type': "application/json"
                    }
                })
                .then((response) => {
                    var videoObjects = this.convertYoutubeObjects(response.data);
                    var results = {
                        playlistName : playlistName,
                        videos: videoObjects
                    }
                    resolve(results);
                    })
                    .catch(error => {
                        reject(error);
                    }
               )
        }); 
    }


    convertYoutubeObjects(object) {
        return object.items.map((item, key) => {
            return {
                title: item.snippet.title,
                url: `https://www.youtube.com/embed/${item.snippet.resourceId.videoId}`,
            };
        })
    }


}




// WEBPACK FOOTER //
// ./src/services/youtubeDataAccess.js